import { render, staticRenderFns } from "./GrowUpMenu.vue?vue&type=template&id=6f6e64e0&scoped=true&"
import script from "./GrowUpMenu.vue?vue&type=script&lang=js&"
export * from "./GrowUpMenu.vue?vue&type=script&lang=js&"
import style0 from "./GrowUpMenu.vue?vue&type=style&index=0&id=6f6e64e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6e64e0",
  null
  
)

export default component.exports